// Seems we need an extra type here (rather than the one defined in SubscriptionService.ts) as
// we also need a quantity
export type AddonCharge = {
    addonId: string;
    addonLabel: string;
    addonUnitPrice: number;
    addonQuantity: number;
    pricingModel: string;

     // Used for FE display - calculated from quantity and unit price
    addonTotalPrice: string;
  };
  
  export type AdditionalChargesState = {
    // This is the "selected" addon that the user is currently viewing
    // - only relevant on the Additional Charges page
    selectedAddon: AddonCharge;
    // This is the list of addons that have been added to the charges
    chargesList: AddonCharge[];
  };
  
  export type AdditionalChargesAction =
    | { type: "SELECT_ADDON_FROM_LIST"; payload: AddonCharge }
    | { type: "ADD_SELECTED_ADDON_TO_CHARGES" }
    | { type: "REMOVE_SELECTED_ADDON_FROM_CHARGES"; payload: Number };
  
  export const additionalChargesInitialState: AdditionalChargesState = {
    selectedAddon: {
      addonId: "",
      addonLabel: "",
      addonUnitPrice: 0,
      addonQuantity: 1,

      pricingModel: "",

      addonTotalPrice: "",
    },
    chargesList: [],
  };
  
  export function additionalChargesReducer(
    state: AdditionalChargesState,
    action: AdditionalChargesAction
  ): AdditionalChargesState {
    switch (action.type) {
      case "SELECT_ADDON_FROM_LIST":
        console.debug("Selected addon from list:", action.payload);
        return {
          ...state,
          selectedAddon: action.payload,
        };
      case "ADD_SELECTED_ADDON_TO_CHARGES":
        console.debug("Adding selected addon to charges:", state.selectedAddon);
        return {
          ...state,
          chargesList: [...state.chargesList, state.selectedAddon],
        };
      case "REMOVE_SELECTED_ADDON_FROM_CHARGES":
        console.debug("Removing selected addon from charges at index:", action.payload);
        return {
          ...state,
          chargesList: state.chargesList.filter((_, i) => i !== action.payload),
        };
      default:
        return state;
    }
  }
  